export  const getDocsFromSnapshot = (snapshot)=>{
    return snapshot.docs.map((doc) =>  ({ id: doc.id, ...doc.data() }))
}

export const generateRandomString = () => {
    const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let randomString = '';
  
    for (let i = 0; i < 10; i++) {
      const randomIndex = Math.floor(Math.random() * alphabet.length);
      randomString += alphabet.charAt(randomIndex);
    }
  
    return randomString;
}

// Array of timestamps


// Function to group timestamps by week, order by key in descending order, and label keys as "Today" or "Yesterday"
export const groupByWeekAndOrderWithLabels = (data) => {
  const grouped = new Map();
  const currentDate = new Date();
  const previousDate = new Date();
  previousDate.setDate(currentDate.getDate() - 1);

  data.forEach((block) => {
    // Get the ISO week number for the timestamp
    const isoWeek = new Date(block.createdAt).toISOString().substring(0, 10);

    if (!grouped.has(isoWeek)) {
      grouped.set(isoWeek, []);
    }

    grouped.get(isoWeek).push(block);
  });

  // Sort the keys in descending order
  const sortedKeys = Array.from(grouped.keys()).sort().reverse();

  // Create a new object to store the grouped data with sorted keys and labels
  const groupedAndOrderedWithLabels = {};

  sortedKeys.forEach((key) => {
    // Get the date from the key
    const date = new Date(key);

    // Label the keys as "Today" or "Yesterday" based on the date
    let label;
    if (date.toDateString() === currentDate.toDateString()) {
      label = 'Today';
    } else if (date.toDateString() === previousDate.toDateString()) {
      label = 'Yesterday';
    } else {
      label = key;
    }

    // Store the grouped data with the label as the key
    groupedAndOrderedWithLabels[label] = grouped.get(key);
  });

  return groupedAndOrderedWithLabels;
};
